module.exports = __webpack_public_path__ + "static/media/heroImage.737ea962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/hero/img/heroImage.jpg
// module id = 1523
// module chunks = 146